import { render, staticRenderFns } from "./hrd-new-trainee-edit.vue?vue&type=template&id=a7c2612a&scoped=true"
import script from "./hrd-new-trainee-edit.vue?vue&type=script&lang=js"
export * from "./hrd-new-trainee-edit.vue?vue&type=script&lang=js"
import style0 from "./hrd-new-trainee-edit.vue?vue&type=style&index=0&id=a7c2612a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c2612a",
  null
  
)

export default component.exports